import React, { ReactNode, useEffect } from "react";
import useAuth from "../../Hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { User } from "../../Types/User";
import { SuperAdmin } from "../../../Constant/Setting";

interface MyComponentProps {
    children: ReactNode; // Ensure you define children prop type
}

const AdminGuard:React.FC<MyComponentProps> = ({children}) => {
    const user:User = useSelector((state:any) => state.UserReducer)
    const navigate = useNavigate()

    useEffect(() => {
        // if(user.role && user.role !== SuperAdmin){
        //     navigate("/home")
        // }
       
    }, [user])
    return <>{children}</>
}
export default AdminGuard